import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { ICurrentLeaveSummary } from '../ICurrentLeaveSummary';
import * as CurrentLeaveSummaryActions from './current-leave-summary.actions';

export const currentLeaveSummariesFeatureKey = 'currentLeaveSummaries';

export interface State extends EntityState<ICurrentLeaveSummary> {
    // additional entities state properties
}

export const adapter: EntityAdapter<ICurrentLeaveSummary> =
    createEntityAdapter<ICurrentLeaveSummary>({
        selectId: (model: ICurrentLeaveSummary) => model.EmployeeListID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const currentLeaveSummaryReducer = createReducer(
    initialState,
    on(CurrentLeaveSummaryActions.addCurrentLeaveSummary, (state, action) =>
        adapter.addOne(action.currentLeaveSummary, state)
    ),
    on(CurrentLeaveSummaryActions.upsertCurrentLeaveSummary, (state, action) =>
        adapter.upsertOne(action.currentLeaveSummary, state)
    ),
    on(CurrentLeaveSummaryActions.addCurrentLeaveSummarys, (state, action) =>
        adapter.addMany(action.currentLeaveSummarys, state)
    ),
    on(CurrentLeaveSummaryActions.upsertCurrentLeaveSummarys, (state, action) =>
        adapter.upsertMany(action.currentLeaveSummarys, state)
    ),
    on(CurrentLeaveSummaryActions.updateCurrentLeaveSummary, (state, action) =>
        adapter.updateOne(action.currentLeaveSummary, state)
    ),
    on(CurrentLeaveSummaryActions.updateCurrentLeaveSummarys, (state, action) =>
        adapter.updateMany(action.currentLeaveSummarys, state)
    ),
    on(CurrentLeaveSummaryActions.deleteCurrentLeaveSummary, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(CurrentLeaveSummaryActions.deleteCurrentLeaveSummarys, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(CurrentLeaveSummaryActions.loadCurrentLeaveSummarys, (state, action) =>
        adapter.setAll(action.currentLeaveSummarys, state)
    ),
    on(CurrentLeaveSummaryActions.clearCurrentLeaveSummarys, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return currentLeaveSummaryReducer(state, action);
}

export const selectCurrentLeaveSummaryState = createFeatureSelector<State>(
    currentLeaveSummariesFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectCurrentLeaveSummaryState);
